import { ConnectedPageLayout } from 'components/layout/page-layout';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { pathManager } from 'routes';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { RouterButton } from '@libs/ui/components/button';
import Typography from '@libs/ui/components/typography';

import { CareerHubPlanCard } from './CareerHubPlanCard';

interface CareerHubPricingProps {}

const useStyles = makeStyles(() => ({
  contentWrapper: {},
  root: {},
  title: {},
}));

export const CareerHubPricing = (props: CareerHubPricingProps) => {
  const { t } = useTranslation('careerHub');

  const CARDS_DATA = [
    {
      type: '123',
      title: t('pricing.cards.kickstart.title'),
      subtitle: t('pricing.cards.kickstart.subtitle'),
      text: t('pricing.cards.kickstart.description'),
      buttonText: t('pricing.cards.kickstart.cta'),
      price: 11.0,
      period: t('pricing.cards.kickstart.price'),
      points: [
        t('pricing.cards.features.unlimitedResumes'),
        t('pricing.cards.features.unlimitedInterview'),
        t('pricing.cards.features.unlimitedNegotiations'),
        t('pricing.cards.features.jobTracker'),
        t('pricing.cards.features.prioritySupport'),
      ],
      paymentLink:
        'https://careerhub.opentalent.co/billing/purchase/66daa9ccb7b6270012f3f821',
    },
    {
      type: '123',
      title: t('pricing.cards.transformation.title'),
      buttonText: t('pricing.cards.transformation.cta'),
      subtitle: t('pricing.cards.transformation.subtitle'),
      text: t('pricing.cards.transformation.description'),
      isBig: true,
      points: [
        t('pricing.cards.features.unlimitedResumes'),
        t('pricing.cards.features.unlimitedInterview'),
        t('pricing.cards.features.unlimitedNegotiations'),
        t('pricing.cards.features.jobTracker'),
        t('pricing.cards.features.prioritySupport'),
      ],
      paymentLink:
        'https://careerhub.opentalent.co/billing/purchase/66daa9994514d200132e822b',
      price: 110.0,
      period: t('pricing.cards.transformation.price'),
      chipText: t('pricing.cards.transformation.badge'),
    },
  ];

  const classes = useStyles();

  return (
    <div>
      <ConnectedPageLayout
        classes={{ contentWrapper: classes.contentWrapper }}
        documentTitle={t('documentTitle')}
        headerProps={{ accountProps: {} }}
        drawerProps={{}}
      >
        <div className={classes.root}>
          <Box>
            <RouterButton
              variant="text"
              startIcon={<ArrowBackIcon />}
              color="info"
              to={pathManager.talent.careerHub.main.generatePath()}
            >
              {t('pricing.back')}
            </RouterButton>
          </Box>
          <Box mb={8} mt={12}>
            <Typography
              className={classes.title}
              variant="h4"
              fontWeight={400}
              textAlign="center"
              family="nohemi"
            >
              {t('pricing.choosePlan')}
            </Typography>
          </Box>
          <Grid
            container
            spacing={12}
            justifyContent="center"
            flexDirection="column"
          >
            <Grid item>
              <Grid container justifyContent="center" spacing={12}>
                {CARDS_DATA.map((d) => (
                  <Grid item key={d.type}>
                    <CareerHubPlanCard {...(d as any)} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </ConnectedPageLayout>
    </div>
  );
};
